import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { EndocrineStressCortisolCortisoneDiagramContent } from "./EndocrineStressCortisolCortisoneDiagram";
import { EndocrineStressCortisolCortisoneKeyContent } from "./EndocrineStressCortisolCortisoneKey";

const SvgEndocrineStressCortisolCortisoneDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1344, 1622)}
      viewBox={diagramOnly ? "0 204 1024 1344" : "0 0 1024 1622"}
    >
      <g id="endocrine-stress-cortisol-cortisone-diagram+key" clipPath="url(#clip0_18293_224303)">
        <rect width={1024} height={diagramOnly ? 1344 : 1622} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <EndocrineStressCortisolCortisoneKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <EndocrineStressCortisolCortisoneDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18293_224303">
          <rect width={1024} height={1622} fill="white" />
        </clipPath>
        <clipPath id="clip1_18293_224303">
          <rect width={1024} height={1344} fill="white" transform="translate(0 204)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgEndocrineStressCortisolCortisoneDiagramKey;
